import AdsError from './AdsError.js'

export class GetAdDetailsError extends AdsError {}
